import React from 'react';
import { Flag } from 'lucide-react';

export interface PriorityBadgeProps {
  priority: 'critical' | 'high' | 'medium' | 'low';
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  className?: string;
}

const PriorityBadge: React.FC<PriorityBadgeProps> = ({
  priority,
  size = 'md',
  showIcon = true,
  className = '',
}) => {
  const getPriorityClasses = (priority: string): string => {
    switch (priority) {
      case 'critical':
        return 'badge-priority-critical';
      case 'high':
        return 'badge-priority-high';
      case 'medium':
        return 'badge-priority-medium';
      case 'low':
        return 'badge-priority-low';
      default:
        return 'badge-neutral';
    }
  };

  const getSizeClasses = (size: string): string => {
    switch (size) {
      case 'sm':
        return 'text-xs px-2 py-0.5';
      case 'lg':
        return 'text-sm px-3 py-1';
      case 'md':
      default:
        return 'text-xs px-2.5 py-0.5';
    }
  };

  const getIconSize = (size: string): string => {
    switch (size) {
      case 'sm':
        return 'h-2.5 w-2.5';
      case 'lg':
        return 'h-4 w-4';
      case 'md':
      default:
        return 'h-3 w-3';
    }
  };

  const formatPriority = (priority: string): string => {
    return priority.charAt(0).toUpperCase() + priority.slice(1);
  };

  return (
    <span
      className={`
        badge
        ${getPriorityClasses(priority)}
        ${getSizeClasses(size)}
        ${className}
      `.trim()}
    >
      {showIcon && <Flag className={`${getIconSize(size)} mr-1`} />}
      {formatPriority(priority)}
    </span>
  );
};

export default PriorityBadge;
